export const baseImageUrl='http://localhost:7050';
 //export const baseImageUrl='';

export const countryCode = "255";

export const isValidUrl = (str) => {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
};